module.exports = __webpack_public_path__ + "img/medal.cd81ae87.svg";